import connectTo from './Container';
import CreativeAnalytics from './CreativeAnalytics';
import { Wrapper } from './Wrapper';

export default connectTo(Wrapper);